import { useCallback, useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import { useFetchOld } from 'hooks';
import { getPots } from '../actions';
import { selectCashWithdrawableBalance, selectPots } from '../reducers/selectors';
/**
 * Get all pots that user has created, and withdrawable cash balance.
 */
const usePots = () => {
    const pots = useAppSelector(selectPots);
    const cashWithdrawable = useAppSelector(selectCashWithdrawableBalance);
    const [, , , fetch] = useFetchOld({
        muteError: true,
        muteResult: true,
        muteFetching: true,
    });
    const getUserPots = useCallback(() => {
        fetch(getPots());
    }, []);
    const potsBalance = useMemo(() => ({
        value: pots.reduce((prev, curr) => prev + curr.balance.value, 0),
        currency: 'GBP',
    }), [pots]);
    return { pots, potsBalance, getUserPots, cashWithdrawable };
};
export default usePots;
